/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useContext} from "react";
import {Title} from "./Common";
import {Checkbox, Col, Form, Row, Switch} from "antd";
import MapPropsContext from "../MapPropsContext";


const WidgetImpCheckSensitivity = ({ currentPark, setMountainReceiveSensitivityTypeList }) => {
  const { onChangeWidgetState, setIsNationalParkHeapmap, isNationalParkHeapmap } = useContext(MapPropsContext);

    const onChange = useCallback(() => {
        setIsNationalParkHeapmap(checked => !checked);
    }, []);

  return (
      <Form.Item>

        <div>
            <Title>수신감도 히트맵</Title>
            <Switch onChange={onChange} checked={isNationalParkHeapmap} />
        </div>
      </Form.Item>
  );
};


export default WidgetImpCheckSensitivity;
